<template>
  <el-card>
    <template #header>
      <content-header>
        广告管理
      </content-header>
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          :to="link"
        >
          <slot>添加广告</slot>
        </button-link>
      </div>
    </div>

    <el-table
      :data="advertisements"
      resource="advertisements"
    >
      <!--<el-table-column
        prop="id"
        label="ID"
        align="center"
        show-overflow-tooltip
        min-width="2%"
      />-->
      <el-table-column
        prop="advertisement_position_id"
        label="广告位"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <div
            v-for="(item,index) in advertisement_position"
            :key="index"
          >
            <el-tag v-if="item.slug == scope.row.advertisement_position_slug">{{ item.name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="广告名称"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="type"
        label="广告类型"
        align="center"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <div
            v-for="(item,index) in advertisement_type"
            :key="index"
          >
            <el-tag v-if="item.slug == scope.row.type">{{ item.name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="sort"
        label="层级"
        align="center"
        show-overflow-tooltip
        min-width="100"
      />
      <el-table-column
        label="广告缩略图"
        align="center"
        show-overflow-tooltip
        min-width="150"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.surface"
            min-width="60"
            height="60"
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="area_name"
        label="投放区域"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />

      <el-table-column
        label="是否展示"
        align="center"
        show-overflow-tooltip
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_display == 1"
            type="success"
          >已展示</el-tag>
          <el-tag
            v-else
            type="danger"
          >未展示</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_time"
        label="开始时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="end_time"
        label="结束时间"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <!-- <el-table-column label="服务时间" width="200">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.customer_service_time }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="customer_service_phone" label="服务手机号"/> -->

      <el-table-column
        label="操作"
        min-width="200"
      >
        <template #default="{ row, $index }">
          <row-to-edit />
          <row-destroy />
            <!--          <button-link-->
            <!--            v-show="row.show_children"-->
            <!--            type="success"-->
            <!--            :to="links(row.id)"-->
            <!--          >-->
            <!--            <slot>管理子广告</slot>-->
            <!--          </button-link>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>
<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import {
  getAdvertisement,
  getAdvertisementSelectData
} from "@/api/advertisement";
import { getAreas } from "@/api/area";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
// import RowAddParking from './components/RowAddParking'

export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "投放区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "advertisement_position_slug",
          label: "广告位",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "type",
          label: "广告类型",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "id",
          label: "ID"
        },
        {
          field: "name",
          label: "名称"
        }
      ],
      advertisements: [],
      page: null,
      advertisement_position: [],
      advertisement_type: [],
      first_blood: true
    };
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        newVal.query.pid = 0;
        const {
          data: { data, meta }
        } = await getAdvertisement(newVal.query);
        this.advertisements = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    addAdvertisement() {
      console.log(111);
    },
    links(id) {
      return `/advertisement-children/` + id;
    }
  },
  computed: {
    link() {
      // this.checkResourceName()
      // console.log(this.identify)
      return `/advertisements/create`;
    }
  },
  async created() {
    const [{ data: selectData }] = await Promise.all([
      getAdvertisementSelectData()
    ]);

    this.advertisement_position = selectData.advertisementPosition;
    this.advertisement_type = selectData.advertisementType;
    // eslint-disable-next-line camelcase
    let type_data = [];
    this.advertisement_type.map(i => {
      type_data.push({ id: i.slug, name: i.name });
    });
    let position_data = [];
    this.advertisement_position.map(i => {
      position_data.push({ id: i.slug, name: i.name });
    });
    // console.log(position_data)
    this.search[1].options.push.apply(this.search[1].options, position_data);
    this.search[2].options.push.apply(this.search[2].options, type_data);
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);
    this.search[0].options.push.apply(this.search[0].options, areas);
    // console.log(this.advertisement_position)
    console.log(areas);
    console.log(position_data);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[5].options.push.apply(
          this.search[5].options,
          merchant.data
        );
      }
    }
  }
};
</script>

<style lang="scss">
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
